// Service Registry Types
// ✅ NO MAGIC STRINGS: Use typed enums and constants

export enum ServiceType {
  SINGLETON = "singleton",
  INSTANCE = "instance",
  FACTORY = "factory",
  STATIC = "static",
}

export interface ServiceConfig {
  name: string;
  type: ServiceType;
  class?: string;
  factory?: string;
  module: string;
  /** Optional interface name — ServiceLoader validates the instance satisfies this contract at startup */
  interface?: string;
  dependencies: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: Record<string, any>;
  enabled: boolean;
  priority: number;
}

export interface ServiceMetadata {
  name: string;
  type: ServiceType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  instance: any;
  initialized: boolean;
  error?: Error;
  dependencies: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: Record<string, any>;
}

export interface ServiceRegistryContract {
  register(config: ServiceConfig): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get<T = any>(name: string): T | undefined;
  initialize(): Promise<void>;
  isInitialized(name: string): boolean;
  getAllServices(): ServiceMetadata[];
  getServiceMetadata(name: string): ServiceMetadata | undefined;
}

export interface ServiceLoaderContract {
  loadService(
    config: ServiceConfig,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dependencies: Map<string, any>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<any>;
}
